import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserEmailNotificationSettings } from '@acp/shared';
import { updateEmailNotificationSettings } from '../service';

export function useEmailNotificationSettingsUpdate() {
    const toast = useToast();
    const queryClient = useQueryClient();

    const updateMutation = useMutation({
        mutationFn: async (settings: UserEmailNotificationSettings) => (
            updateEmailNotificationSettings(settings)
        ),
        onSuccess: (_settings, variables) => {
            toast({
                title: 'Email notification preferences updated',
                description: 'Email notification preferences have been saved.',
                status: 'success',
                isClosable: true,
            });

            void queryClient.invalidateQueries({
                queryKey: ['me', 'email-notification-settings', variables.email],
            });
        },
        onError: (error) => {
            toast({
                title: 'Error updating email notification preferences',
                description: error.message,
                status: 'error',
                isClosable: true,
            });
        },
    });

    return {
        update: updateMutation.mutateAsync,
        isPending: updateMutation.isPending,
        reset: updateMutation.reset,
    };
}
